(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-policy"]) return;
  try {
    
  (function () {
    var toc = document.getElementById('toc-links');
    if (!toc) return;
    var headings = Array.from(document.querySelectorAll('.pp-article h2, .pp-article h3'));
    headings.forEach(function (h, i) {
      var txt = h.textContent.replace(/\s+/g, ' ').trim();
      var slug = 'sec-' + txt.toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') + '-' + i;
      h.id = slug;
      var a = document.createElement('a');
      a.href = '#' + slug;
      a.textContent = txt;
      toc.appendChild(a);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
